export default __webpack_public_path__ + "static/media/mitsubishi.c488ee90.png";